import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    currentLang: '',
  },
  mutations: {
    updateLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    updateCurrentLang(state, currentLang) {
      state.currentLang = currentLang;
    },
  },
  actions: {
  },
  modules: {
  },
});
